/** 登录 / 注册弹窗。取消即进入离线模式。 */
import { useState } from 'react';
import { Button, Form, Input, Modal, Tabs, message } from 'antd';
import { api } from './client';
import { setToken, useAuthStore } from './auth';

export function AuthModal() {
  const open = useAuthStore((s) => s.open);
  const finish = useAuthStore((s) => s.finish);
  const [tab, setTab] = useState<'login' | 'register'>('login');
  const [loading, setLoading] = useState(false);

  const onSubmit = async (values: { email: string; password: string }) => {
    setLoading(true);
    try {
      const res = tab === 'login' ? await api.login(values) : await api.register(values);
      setToken(res.token);
      message.success(tab === 'login' ? '登录成功' : '注册成功');
      finish(true);
    } catch (err) {
      message.error((err as Error).message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <Modal
      open={open}
      title="登录后可云端保存与发布"
      footer={null}
      closable={false}
      maskClosable={false}
      destroyOnClose
    >
      <Tabs activeKey={tab} onChange={(k) => setTab(k as 'login' | 'register')} items={[{ key: 'login', label: '登录' }, { key: 'register', label: '注册' }]} />
      <Form layout="vertical" onFinish={onSubmit} autoComplete="off">
        <Form.Item name="email" label="邮箱" rules={[{ required: true, type: 'email', message: '请输入正确的邮箱' }]}>
          <Input placeholder="you@example.com" />
        </Form.Item>
        <Form.Item name="password" label="密码" rules={[{ required: true, min: 6, message: '至少 6 位' }]}>
          <Input.Password />
        </Form.Item>
        <div style={{ display: 'flex', gap: 8, justifyContent: 'flex-end' }}>
          <Button onClick={() => finish(false)}>离线使用</Button>
          <Button type="primary" htmlType="submit" loading={loading}>{tab === 'login' ? '登录' : '注册并登录'}</Button>
        </div>
      </Form>
    </Modal>
  );
}
